import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneWebsiteUpdateInfo from './submodules/clone';
import CreateWebsiteUpdateInfoV2 from './submodules/create';
import ListWebsiteUpdateInfo from './submodules/list';
import EditWebsiteUpdateInfo from './submodules/edit';

const WebsiteUpdateDashboardV2: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getWebsiteUpdatesV2]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListWebsiteUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addWebsiteUpdateInfoV2]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneWebsiteUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addWebsiteUpdateInfoV2]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateWebsiteUpdateInfoV2}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateWebsiteUpdateInfoV2]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditWebsiteUpdateInfo}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default WebsiteUpdateDashboardV2;
